var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainImgPill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.966,
    height: 66.966,
    viewBox: "0 0 66.966 66.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_313",
    "data-name": "\\uADF8\\uB8F9 313",
    transform: "translate(-1471.403 -726.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_50",
    "data-name": "\\uD0C0\\uC6D0 50",
    transform: "translate(1471.403 726.657)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.483,
    cy: 33.483,
    r: 33.483,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.483,
    cy: 33.483,
    r: 32.483,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_197",
    "data-name": "\\uC120 197",
    y2: 66.966,
    transform: "translate(1504.886 726.657)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainImgPill);
export default __webpack_public_path__ + "static/media/main_img_pill.e4171d83b5c51f1a1e6a5ab8f18df1b7.svg";
export { ForwardRef as ReactComponent };